import React from 'react';
import PropTypes from 'prop-types';
import { Confirm } from 'react-confirm-bootstrap';
import { MenuItem } from 'react-bootstrap/lib';

function DeleteButton({ website, onDelete }) {
  return (
    <Confirm
      onConfirm={() => onDelete(website.id)}
      body={`Are you sure you want to remove ${website.name}?`}
      confirmText="Confirm Delete"
      title={`Deleting ${website.name}`}
    >
      <MenuItem>Delete</MenuItem>
    </Confirm>
  );
}

DeleteButton.propTypes = {
  website: PropTypes.object,
  onDelete: PropTypes.func,
};

export default DeleteButton;
